import { Link } from 'react-router-dom';
import { useSiteContent } from '../context/SiteContentContext';
import PageTitle from '../components/ui/PageTitle';
import './NotFoundPage.css';

export default function NotFoundPage() {
  var content = useSiteContent();
  var c = content.c;

  return (
    <>
      <PageTitle title="Page Not Found" />
      <div className="container container--reading nf-page">
        <div className="nf-icon">404</div>
        <h1 className="nf-heading">{c('error_404_heading', 'This page wandered off')}</h1>
        <p className="nf-body">{c('error_404_body', 'It might have been moved or no longer exists.')}</p>
        <div className="nf-actions">
          <Link to="/shop" className="nf-btn-primary">Browse the collection</Link>
          <Link to="/" className="nf-btn-ghost">Go to homepage</Link>
        </div>
      </div>
    </>
  );
}